export const AppSwitcherTitles = ['Your applications', 'Other services'];
